<template>
  <div>

    <div class="top-content">
      <button
        class="buto"
        @click="$router.back()"
      >返回</button>
    </div>

    <div class="detail">
      <div v-if="List&&List.length>0">
        <div
          class=""
          v-for="(item,index) in List"
          :key="index"
        >
          <div style="font-size: 16px;font-weight: 700;">
            <div
              style="display: inline-block;"
              @click="uodateTeamName(item.id,item.name)"
            >{{item.name}} <span style="vertical-align: middle;">
                <van-icon
                  name="info"
                  size="20"
                  color="#1989fa"
                />
              </span></div>
            <span
              class="remove"
              @click="onDelete(item)"
            >
              <van-icon
                name="clear"
                size="20"
                color="#ee0a24"
              />
            </span>
          </div>
          <div class="p10-size14">
            <div class="title-s">队长</div>
            <div
              class="value-s"
              @click.stop="addTeam(item.id,'设置大队长')"
            >
              <div class="flex-e"><span :class="item.captain_name?'size-box':''">{{item.captain_name||'请选择'}}</span></div>
            </div>
          </div>
          <div class="p10-size14">
            <div class="title-s">协调员</div>
            <div
              class="value-s"
              @click.stop="addJob(item.id,'协调员')"
            >
              <div class="flex-e">
                <span
                  class="size-box"
                  v-for="(oitem,oindex) in item.observers"
                  :key="oindex"
                >{{oitem}}</span>
                <div v-show="item.observers.length==0">请选择</div>
              </div>
            </div>
          </div>
          <div class="p10-size14">
            <div class="title-s">领队</div>
            <div
              class="value-s"
              @click.stop="addJob(item.id,'领队')"
            >
              <div class="flex-e">
                <span
                  class="size-box"
                  v-for="(litem,lindex) in item.guide"
                  :key="lindex"
                >{{litem}}</span>
                <div v-show="item.guide.length==0">请选择</div>
              </div>
            </div>
          </div>
          <div class="p10-size14">
            <div class="title-s">摄影师</div>
            <div
              class="value-s"
              @click.stop="addJob(item.id,'摄影师')"
            >
              <div class="flex-e"><span
                  class="size-box"
                  v-for="(sitem,sindex) in item.photog"
                  :key="sindex"
                >{{sitem}}</span>
                <div v-show="item.photog.length==0">请选择</div>
              </div>
            </div>
          </div>
          <!-- 中队的循环 -->
          <div
            v-for="(item2,index2) in item.m_teams"
            :key="index2"
          >
            <div style="font-size: 16px;font-weight: 700;padding:20px 0;">
              <div
                style="display: inline-block;"
                @click="uodateTeamName(item2.id,item2.name)"
              >{{item2.name}}
                <span style="vertical-align: middle;">
                  <van-icon
                    name="info"
                    size="20"
                    color="#1989fa"
                  />
                </span>

              </div>
              <span
                class="remove"
                @click="onDelete(item2)"
              >
                <van-icon
                  name="clear"
                  size="20"
                  color="#ee0a24"
                />
              </span>
            </div>
            <div class="p10-size14">
              <div class="title-s">队长</div>
              <div
                class="value-s"
                @click.stop="addTeam(item2.id,'设置中队长')"
              >
                <div class="flex-e"><span :class="item2.captain_name?'size-box':''">{{item2.captain_name||'请选择'}}</span></div>
              </div>
            </div>
            <div class="p10-size14">
              <div class="title-s">协调员</div>
              <div
                class="value-s"
                @click.stop="addJob(item2.id,'协调员')"
              >
                <div class="flex-e"><span
                    class="size-box"
                    v-for="(oitem2,oindex2) in item2.observers"
                    :key="oindex2"
                  >{{oitem2}}</span>
                  <div v-show="item2.observers.length==0">请选择</div>
                </div>
              </div>
            </div>
            <div class="p10-size14">
              <div class="title-s">领队</div>
              <div class="value-s">
                <div
                  class="flex-e"
                  @click.stop="addJob(item2.id,'领队')"
                ><span
                    class="size-box"
                    v-for="(litem2,lindex2) in item2.guide"
                    :key="lindex2"
                  >{{litem2}}</span>
                  <div v-show="item2.guide.length==0">请选择</div>
                </div>
              </div>
            </div>
            <div class="p10-size14">
              <div class="title-s">摄影师</div>
              <div
                class="value-s"
                @click.stop="addJob(item2.id,'摄影师')"
              >
                <div class="flex-e"><span
                    class="size-box"
                    v-for="(sitem2,sindex2) in item2.photog"
                    :key="sindex2"
                  >{{sitem2}}</span>
                  <div v-show="item2.photog.length==0">请选择</div>
                </div>
              </div>
            </div>
            <!-- 小队的循环 -->
            <div
              v-for="(item3, index3) in item2.s_teams"
              :key="index3"
            >
              <div style="font-size: 16px;font-weight: 700;padding:20px 0;">
                <div
                  style="display: inline-block;"
                  @click="uodateTeamName(item3.id,item3.name)"
                >{{item3.name}}
                  <span style="vertical-align: middle;">
                    <van-icon
                      name="info"
                      size="20"
                      color="#1989fa"
                    />
                  </span>

                </div>
                <span
                  class="remove"
                  @click="onDelete(item3)"
                >
                  <van-icon
                    name="clear"
                    size="20"
                    color="#ee0a24"
                  />
                </span>
              </div>
              <div class="p10-size14">
                <div class="title-s">队长</div>
                <div
                  class="value-s"
                  @click.stop="addTeam(item3.id,'设置小队长')"
                >
                  <div class="flex-e"><span :class="item3.captain_name?'size-box':''">{{item3.captain_name||'请选择'}}</span></div>
                </div>
              </div>
              <div class="p10-size14">
                <div class="title-s">协调员</div>
                <div
                  class="value-s"
                  @click.stop="addJob(item3.id,'协调员')"
                >
                  <div class="flex-e"><span
                      class="size-box"
                      v-for="(oitem3,oindex3) in item3.observers"
                      :key="oindex3"
                    >{{oitem3}}</span>
                    <div v-show="item3.observers.length==0">请选择</div>

                  </div>
                </div>
              </div>
              <div class="p10-size14">
                <div class="title-s">领队</div>
                <div
                  class="value-s"
                  @click.stop="addJob(item3.id,'领队')"
                >
                  <div class="flex-e"><span
                      class="size-box"
                      v-for="(litem3,lindex3) in item3.guide"
                      :key="lindex3"
                    >{{litem3}}</span>
                    <div v-show="item3.guide.length==0">请选择</div>
                  </div>
                </div>
              </div>
              <div class="p10-size14">
                <div class="title-s">摄影师</div>
                <div
                  class="value-s"
                  @click.stop="addJob(item3.id,'摄影师')"
                >
                  <div class="flex-e"><span
                      class="size-box"
                      v-for="(sitem3,sindex3) in item3.photog"
                      :key="sindex3"
                    >{{sitem3}}</span>
                    <div v-show="item3.photog.length==0">请选择</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 小队的循环 -->

          </div>
          <!-- 中队的循环 -->

        </div>
      </div>
      <div
        v-show="List.length == 0"
        style="margin:auto"
      >
        <van-empty description="暂无队伍" />
      </div>
    </div>

    <van-dialog
      v-model="attendanceShow"
      width="200"
      :title="teamValue"
      :showCancelButton="true"
      confirm-button-text="提交"
      @cancel="cancel()"
      @confirm="confirm()"
    >
      <div style="padding:10px 50px;border-top: 1px solid #999;border-bottom: 1px solid #999;">
        <div>
          <van-radio-group v-model="radioValue">
            <van-radio
              icon-size="15"
              v-for="(item,index) in teamList"
              :key="index"
              :name="item.id"
              style="margin-bottom: 5px;"
            >{{item.name}}</van-radio>
          </van-radio-group>

        </div>
      </div>
    </van-dialog>

    <van-dialog
      v-model="jobShow"
      width="300"
      title="选择伙伴"
      :showCancelButton="true"
      confirm-button-text="提交"
      @cancel="jobcancel()"
      @confirm="jobconfirm()"
    >
      <div style="padding:10px 30px;border-top: 1px solid #999;border-bottom: 1px solid #999;">
        <div style="display:flex;justify-content: space-between;flex-wrap: wrap;">
          <div
            style="padding:10px 2px;display: inline-block;width: 48%;"
            v-for="(item,index) in teamList"
            :key="index"
          >
            <div style="vertical-align:  middle;display: inline-block;">
              <div style="float:right">
                <van-checkbox v-model="item.arrive">
                </van-checkbox>
              </div>
            </div>
            <div style="display: inline-block;padding: 0 5px;">{{item.name}}</div>
          </div>
        </div>

      </div>
    </van-dialog>

    <van-dialog
      v-model="submitChildShow"
      title="修改队名"
      :showCancelButton="true"
      @cancel="submitChildShow=false"
      @confirm="submitChildConfirm()"
    >
      <div style="padding:5px;">
        <div style="border: 1px solid #f1f1f1;">
          <van-field
            v-model="submitChildValue"
            type="text"
            autosize
            row="5"
            placeholder="队伍姓名"
          />
        </div>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import { Dialog } from 'vant'
export default {
  data() {
    return {
      project_id: '',
      List: [],
      teamList: [],
      attendanceShow: false,
      radioValue: '',
      teamId: '',
      teamValue: '',
      jobShow: false,
      jobValue: '',
      dateTeamNameShow: false,
      submitChildShow: false,
      submitChildValue: '',
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.getList()
    this.getTeamList()
  },
  methods: {
    orSplit(value) {
      if (value) {
        value = value.split(',')
      } else {
        value = []
      }
      return value
    },
    getList() {
      this.$axios
        .get('project/team-tree', {
          params: {
            project_id: this.project_id,
          },
        })
        .then((res) => {
          let data = res.data.data

          for (let i = 0; i < data.length; i++) {
            let dataItem = data[i]
            dataItem.observers = this.orSplit(dataItem.observers)
            dataItem.photog = this.orSplit(dataItem.photog)
            dataItem.guide = this.orSplit(dataItem.guide)

            for (let j = 0; j < dataItem.m_teams.length; j++) {
              let m_teams = dataItem.m_teams[j]
              m_teams.observers = this.orSplit(m_teams.observers)
              m_teams.photog = this.orSplit(m_teams.photog)
              m_teams.guide = this.orSplit(m_teams.guide)

              for (let k = 0; k < m_teams.s_teams.length; k++) {
                let s_teams = m_teams.s_teams[k]
                s_teams.observers = this.orSplit(s_teams.observers)
                s_teams.photog = this.orSplit(s_teams.photog)
                s_teams.guide = this.orSplit(s_teams.guide)
              }
            }
          }
          console.log(data)
          this.List = data
        })
    },
    getTeamList() {
      this.$axios
        .get('partner/list-in-project', {
          params: {
            project_id: this.project_id,
          },
        })
        .then((res) => {
          let data = res.data.data
          for (let i = 0; i < data.length; i++) {
            data[i].arrive = false
          }
          console.log(res)
          this.teamList = data
        })
    },
    addTeam(id, param) {
      this.teamValue = param
      this.teamId = id
      this.attendanceShow = true
    },
    cancel() {
      this.attendanceShow = false
      this.radioValue = ''
      this.teamId = ''
    },
    confirm() {
      this.$axios
        .post('project/team-set-captain', {
          team_id: this.teamId,
          partner_id: this.radioValue,
        })
        .then((res) => {
          this.attendanceShow = false
          this.radioValue = ''
          this.teamId = ''
          this.getList()
          this.getTeamList()
          this.$toast(res.data.msg)
        })
    },
    addJob(id, job) {
      this.teamId = id
      this.jobValue = job
      this.jobShow = true
    },
    jobcancel() {
      for (let i = 0; i < this.teamList.length; i++) {
        this.teamList[i].arrive = false
      }
      this.jobShow = false
    },
    jobconfirm() {
      let arrive_ids = []
      for (let i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].arrive == 1) {
          arrive_ids.push(this.teamList[i].id)
        }
      }
      this.$axios
        .post('project/team-set-staff', {
          job: this.jobValue,
          team_id: this.teamId,
          partner_id: arrive_ids,
        })
        .then((res) => {
          this.jobValue = ''
          this.teamId = ''
          for (let i = 0; i < this.teamList.length; i++) {
            this.teamList[i].arrive = false
          }
          this.getList()
          this.$toast(res.data.msg)
        })
    },
    uodateTeamName(id, name) {
      this.teamId = id
      this.submitChildShow = true
      this.submitChildValue = name
    },
    submitChildConfirm() {
      this.$axios
        .post('project/update-team', {
          team_id: this.teamId,
          team_name: this.submitChildValue,
        })
        .then((res) => {
          this.teamId = ''
          this.submitChildValue = ''
          this.getList()
          this.$toast(res.data.msg)
        })
    },
    onDelete(item) {
      Dialog.alert({
        message: '确认删除',
        showCancelButton: true,
      })
        .then((res) => {
          this.$axios
            .post('project/team-delete', {
              team_id: item.id,
            })
            .then((res) => {
              this.$toast(res.data.msg)
              this.getList()
            })
        })
        .catch((err) => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.detail {
  padding: 70px 10px;
}

.top-content {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
  z-index: 99;
}

.buttons {
  color: #fff;
  padding: 9px 20px;
  border: none;
  border-radius: 6px;
}
.cwbf {
  color: #000;
  border: 1px solid #666;
}
.buto {
  vertical-align: top;
  background-color: #ee0a24;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
}


.p10-size14 {
  display: inline-block;
  padding: 5px 0;
  font-size: 14px;
  width: 48%;
  vertical-align: top;

  .title-s {
    display: inline-block;
    // width: 30%;
    font-weight: 500;
    vertical-align: top;
  }

  .value-s {
    display: inline-block;
    color: #999;
    width: 70%;
    .flex-e {
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
    }

    .size-box {
      padding: 2px 0;
      text-align: center;
      border: 1px solid #333;
      font-size: 11px;
      width: 40%;
      // margin-top: 2px;
      border-radius: 5px;
    }
    .flex-e:after {
      content: '';
      width: 40%;
    }
  }
}
.remove {
  vertical-align: middle;
  margin-left: 10px;
}
</style>